/**
 * ADR-220 §7.2 — when the due reminder may appear (pure). Mirrors the app's
 * reminder_engagement_rule.dart; both are tested against
 * design/reco/reminder_engagement_cases.json
 * (scripts/tests/eros-reminder.test.mjs). Times are milliseconds.
 */
(function (root) {
  'use strict';

  var DEFAULTS = { enabled: false, minScore: 4, settleMs: 6000, warmupMs: 90000, backgroundResetMs: 120000 };

  function config(over) {
    return Object.assign({}, DEFAULTS, over || {});
  }

  function coldStart(now) {
    return { sessionStart: now, score: 0, screen: 'other', screenSince: null, overlayOpen: false, shown: false, backgroundSince: null };
  }

  function with_(e, patch) {
    return Object.assign({}, e, patch);
  }

  function productOpened(e) { return with_(e, { score: e.score + 1 }); }
  function searched(e) { return with_(e, { score: e.score + 1 }); }
  function addedToCart(e) { return with_(e, { score: e.score + 2 }); }
  function screenChanged(e, screen, now) { return with_(e, { screen: screen, screenSince: now }); }
  function overlayChanged(e, open) { return with_(e, { overlayOpen: !!open }); }
  function cardShown(e) { return with_(e, { shown: true }); }
  function backgrounded(e, now) { return with_(e, { backgroundSince: now }); }

  function resumed(e, now, cfg) {
    if (e.backgroundSince !== null && now - e.backgroundSince >= cfg.backgroundResetMs) {
      return { sessionStart: now, score: 0, screen: e.screen, screenSince: now, overlayOpen: e.overlayOpen, shown: false, backgroundSince: null };
    }
    return with_(e, { backgroundSince: null });
  }

  function mayRemind(e, now, cfg) {
    return !!cfg.enabled &&
      !e.shown &&
      e.backgroundSince === null &&
      !e.overlayOpen &&
      e.score >= cfg.minScore &&
      e.screen === 'browse' &&
      e.screenSince !== null &&
      now - e.screenSince >= cfg.settleMs &&
      now - e.sessionStart >= cfg.warmupMs;
  }

  function nextCheckAt(e, cfg) {
    if (!cfg.enabled || e.shown || e.screenSince === null) return null;
    return Math.max(e.screenSince + cfg.settleMs, e.sessionStart + cfg.warmupMs);
  }

  /** Shopify page types where the card may float (browsing only). */
  var BROWSE = { product: 1, collection: 1, 'list-collections': 1, search: 1, searchresults: 1 };
  function screenFor(pageType, path) {
    if (/\/pages\/wishlist/.test(path || '')) return 'browse';
    return BROWSE[pageType] ? 'browse' : 'other';
  }

  var api = {
    config: config,
    coldStart: coldStart,
    productOpened: productOpened,
    searched: searched,
    addedToCart: addedToCart,
    screenChanged: screenChanged,
    overlayChanged: overlayChanged,
    cardShown: cardShown,
    backgrounded: backgrounded,
    resumed: resumed,
    mayRemind: mayRemind,
    nextCheckAt: nextCheckAt,
    screenFor: screenFor
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ErosReminderRules = api;
})(typeof window !== 'undefined' ? window : globalThis);
